export const normaliseData = (
  data?: Record<string, number>
): [Date, number][] => {
  if (typeof data === 'undefined') return [];
  return Object.entries(data || {}).map(([date, value]) => {
    return [new Date(date), value];
  });
};
